export default {
  labNumberType: "ALPHANUM",
  usePrefix: false,
  alphanumPrefix: "",
};
